<template>
<v-row wrap>
    <v-dialog v-model="dialog" persistent max-width="500">
        <v-card>
            <v-card-title class="justify-center">
                {{dialogtext}}
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialog = false">
                    No
                </v-btn>
                <v-btn color="green darken-1" text @click="confirm">
                    Yes
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-col cols="12">
        <v-row justify="center" style="padding-top:5vh">
            <v-card height="20%">

                <v-card-title v-if="data.showtable" width="100%">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="data.showtable" width="100" :single-expand="singleExpand" :headers="header" show-expand :items="data.datatable" :items-per-page="6" item-key="booking_id" :footer-props="{ 'items-per-page-options': [6,9]}" :search="search" class="elevation-1 ">

                    <template v-slot:item.booking_status="{ item }">
                        <v-chip v-if="item.booking_status === 'booking'" color="yellow darken-1" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'checkin'" color="light-blue lighten-3" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'success'" color="light-green darken-1" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'cancel'" color="orange darken-2" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'cancel by admin'" color="orange darken-2" dark>
                            {{ item.booking_status }}
                        </v-chip>
                        <v-chip v-if="item.booking_status === 'autocancel'" color="deep-orange darken-4" dark>
                            {{ item.booking_status }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <!-- <v-menu > -->
                        <v-btn fab icon small @click="editItem(item)">
                            <v-icon color="light-blue accent-4">
                                mdi-dots-horizontal
                            </v-icon>
                        </v-btn>

                        <!-- </v-menu> -->
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" style="padding-left:10vh">
                            <p style="margin-bottom: 0vh;">Booking by : {{item.booking_by}} <span style="margin-left: 40px;"></span>Email : {{item.email}}<span style="margin-left: 40px;"></span>Phone : {{item.phone}}</p>
                        </td>
                    </template>

                </v-data-table>
            </v-card>

        </v-row>
    </v-col>
</v-row>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data() {
        return {
            booking: null,
            dialog: false,
            search: '',
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            dialogtext: null,
            singleExpand: true,

            header: [{
                    "text": "Topic",
                    "value": "topic",
                    width: '120',
                },
                {
                    "text": "Time use",
                    "value": "date_time_use",
                    width: '200',
                },
                {
                    "text": "Time end",
                    "value": "date_time_end",
                    width: '200',
                },
                {
                    "text": "Room name",
                    "value": "room_name",
                    width: '120',
                },
                {
                    "text": "Status",
                    "value": "booking_status",
                    width: '100',
                    align: 'center'
                    // align: 'center'
                },
                // {
                //     "text": "Booking by",
                //     "value": "booking_by",
                //     width: '200',
                //     align: 'center'
                // },
                // {
                //     "text": "Email",
                //     "value": "email"
                // },
                // {
                //     "text": "Phone",
                //     "value": "phone"
                // },
                {
                    "text": "Action",
                    "value": "action",
                    width: '100',
                    sortable: false
                }
            ],
        }
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        },
        ...mapState('datas', {
            data: 'data'
        }),
    },

    created() {
        // this.$store.dispatch("datas/getbooking")
        this.$store.dispatch("datas/getbooking")
    },

    methods: {
        editItem(item) {
            if (item.booking_status == "cancel" || item.booking_status == "checkin") {
                // console.log(item)
                // this.dialogtext = 'Do you want to book this booking?'
                // this.dialog = true
            } else if (item.booking_status != "cancel" || item.booking_status != "checkin") {
                // console.log(item)
                this.dialogtext = 'Do you want to cancel this booking?'
                this.dialog = true
            }
            this.booking = item

        },
        confirm() {
            let payload = new FormData()
            let status
            if (this.booking.booking_status != "cancel") {
                status = "cancel by admin"
            } else if (this.booking.booking_status == "cancel") {
                status = "booking"
            }
            payload.append('booking_id', this.booking.booking_id)
            payload.append('status', status)
            this.$store.dispatch("datas/changebookingstatus", payload)
            console.log(this.booking)
            this.dialog = false
        }

    },
}
</script>

<style>

    </style>
